import Sheet from 'components/utils/Sheet'

import CruisePageUSPsSection from './CruisePageUSPsSection'

function CruisePageWhyBookWithUsSection() {
  return (
    <Sheet background="light-background" padding="32 0">
      <CruisePageUSPsSection />
    </Sheet>
  )
}

export default CruisePageWhyBookWithUsSection
